<template>
  <employeeList options add link/>
</template>

<script>
import employeeList from '@/components/employees/employeesList'

export default {
name: 'employeesPage',

components: {
  employeeList
}
}
</script>